import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  baseStyles,
  BORDER_RADIUS,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  withMediaQueries,
  withMultipleStyles
} from "../../../styles/Styles";
import {
  ColorCardField,
  ColorCardFieldHover,
  ColorCardFieldSelected,
  ColorTheme,
  ColorTitle
} from "../../../styles/Colors";
import {Button, FormHelperText} from "@material-ui/core";
import GridList from "@material-ui/core/GridList";
import Space from "../commons/Space";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import TextView from "../commons/TextView";
import ValueHelper from "../../utils/ValueHelper";
import {FormattedMessage} from "react-intl";
import DateTimeHelper from "../../utils/DateTimeHelper";
import {isCurrentPlanEnded} from "../../utils/ActivityHelper";
import {logDebug} from "../../utils/AppLog";

const useStyles = () => ({
  planCardWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: 1200,
  },
  planCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    margin: 8,
    minHeight: 86,
  },
  planCardButtonBase: {
    margin: 12,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    maxWidth: 340,
    minWidth: 280,
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  planCardButtonBaseSelected: {
    margin: 12,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    maxWidth: 340,
    minWidth: 280,
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    border: '2px solid '+ ColorTheme,
    backgroundColor: ColorCardFieldSelected,
  }
});

class ManageActivityPlan extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.currencyCode = 'SAR';
    this.plans = null;
    this.oldPlan = null;
    this.oldPlanType = 0;
    this.oldPlanId = 0;
    const ad = activityData.ad;
    if (ad && ad.planId) {
      this.oldPlan = ad;
      this.oldPlanType = this.oldPlan.planType;
      this.oldPlanId = this.oldPlan.planId;
    }
    const adInfo = activityData.adInfo;
    if (adInfo) {
      this.currencyCode = adInfo.currencyCode;
      this.plans = adInfo.plans;
    }
    let planId = 0;
    let planType = 0;
    if (this.plans) {
      this.plans.forEach((plan) => {
        if (plan.id === activityData.planId) {
          planId = activityData.planId;
          planType = activityData.planType;
        }
      });
    }
    if (planId && planId === this.oldPlanId && isCurrentPlanEnded(this.oldPlan)) {
      planId = 0;
      planType = 0;
    }

    this.state = {
      planId: planId,
      planType: planType,
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    if (!this.state.planId) {
      this.props.onDataUpdated(this.getData(true));
    }
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    let {
      planId,
      planType,
    } = this.state;

    if (!excludeError) {
      if (!planId || !planType) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    return {
      planId,
      planType,
      ['disableNext'+ this.props.tabId]: !planId
    };
  }

  render() {
    const {classes, isXS} = this.props;
    const {showValidationMsg, planType, planId} = this.state;

    let planError = null;
    if (showValidationMsg) {
      if (!planId || !planType) {
        planError = this.context.intl.formatMessage({id: 'activity.manage.selectPlan'});
      }
    }

    return (
      <div className={classes.formBoxSelection}>
        <div className={planError != null ? classes.boxesViewFieldError : classes.boxesViewField}>
          <div className={classes.boxesView}>
            <GridList cols={isXS ? 1 : 3} className={classes.planCardWrapper} cellHeight={'auto'}>
              {this.plans.map((item, index) => (this.getSubscriptionPlanView(item)))}
            </GridList>
          </div>
          {planError != null && <FormHelperText className={classes.helperError}>{planError}</FormHelperText>}
        </div>
      </div>
    )
  }

  getSubscriptionPlanView(plan) {
    const {classes} = this.props;
    const {planId} = this.state;
    const freePlanType = 2;
    const paidPlanType = 3;

    let durationText = <FormattedMessage id={'activity.plan.unlimited'} />;
    if (plan.duration > 0) {
      if (plan.duration === 1) {
        durationText = <FormattedMessage id={'activity.plan.durationDay'} values={{value: plan.duration}}/>;
      } else {
        if (plan.type === paidPlanType) {
          if (plan.duration === 365) {
            durationText = <FormattedMessage id={'activity.plan.durationUptoYear'}/>;
          } else {
            durationText = <FormattedMessage id={'activity.plan.durationUptoDays'} values={{value: plan.duration}}/>;
          }
        } else {
          durationText = <FormattedMessage id={'activity.plan.durationDays'} values={{value: plan.duration}}/>;
        }
      }
    }
    let priceText = null;
    if (plan.type === freePlanType) {
      priceText = <FormattedMessage id={'activity.plan.priceFree'} />;
    } else {
      priceText = <FormattedMessage id={'activity.plan.priceFromValue'} values={{value1: this.currencyCode, value2: ValueHelper.getDisplayValue(plan.price, 2)}} />;
    }
    let viewsCountText = <FormattedMessage id={'activity.plan.flexible'} />;
    if (plan.viewsCount > 0) {
      if (plan.type === paidPlanType) {
        viewsCountText = <FormattedMessage id={'activity.plan.uptoValue'} values={{value: ValueHelper.getDisplayValue(plan.viewsCount)}}/>;
      } else {
        viewsCountText = ValueHelper.getDisplayValue(plan.viewsCount);
      }
    }
    let viewsCountPerDayText = <FormattedMessage id={'activity.plan.flexible'} />;
    if (plan.viewsCountPerDay > 0) {
      viewsCountPerDayText = ValueHelper.getDisplayValue(plan.viewsCountPerDay);
    }

    let isPlanEnded = false;
    let availableViewsText = null;
    let endAtLabelText = '';
    let endAtText = '';
    if (this.oldPlan) {
      const availableViews = Math.max(0, plan.viewsCount - this.oldPlan.feedDisplayedCount);
      availableViewsText = ValueHelper.getDisplayValue(availableViews);

      const planEndAt = this.oldPlan.planEndAt;
      const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(planEndAt);
      if (endDateDiff > 0) {
        endAtLabelText = <FormattedMessage id='activity.plan.endingInTime' />;
        endAtText = DateTimeHelper.getValidity(planEndAt);
      }

      if (availableViews === 0 || endDateDiff <= 0) {
        isPlanEnded = true;
      }
    }

    let buttonText = null;
    let buttonEnabled = true;
    if (plan.price > 0) {
      buttonText = <FormattedMessage id={'activity.plan.choosePlanWithValue'} values={{value1: this.currencyCode, value2: plan.price}} />;
    } else {
      const effLimit = Math.max(0, plan.available);
      if (this.oldPlanType > 1) {
        if (this.oldPlanType === freePlanType) {
          if (isCurrentPlanEnded(this.oldPlan)) {
            buttonEnabled = false;
            buttonText = <FormattedMessage id={'activity.plan.buttonFreeOver'}/>;
          } else {
            buttonText = <FormattedMessage id={'activity.plan.buttonContinuePlanWithValue'} values={{value: plan.name}} />;
          }
        } else {
          buttonEnabled = false;
          buttonText = <FormattedMessage id={'activity.plan.buttonFreeOver'}/>;
        }
      } else if (effLimit > 0) {
        buttonText = <FormattedMessage id={'activity.plan.buttonFree'} values={{value: effLimit}} />;
      } else {
        buttonEnabled = false;
        buttonText = <FormattedMessage id={'activity.plan.buttonFreeLimitExhausted'} />;
      }
    }
    return (
      <div
        className={plan.id === planId ? classes.planCardButtonBaseSelected : classes.planCardButtonBase}
        onClick={() => {}}>
        <div className={classes.flexColumnNoCenter} style={{padding: 16, paddingTop: 8}}>
          <TextView text={plan.name} variant="subtitle1" color={ColorTheme} fontWeight={plan.id === planId ? FONT_WEIGHT_BOLD : FONT_WEIGHT_MEDIUM} align={'center'} />
          <Space horizontalSpace={3}/>
          <div className={classes.flexRow}>
            <TextView textId={'activity.plan.viewsCount'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView text={viewsCountText} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.flexRow}>
            <TextView textId={'activity.plan.viewsCountPerDay'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView text={viewsCountPerDayText} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.duration'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView text={durationText} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.userTargeting'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.rab7AppDisplay'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.cta1'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.cta2'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.analytics'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.rechargeFree'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.reward'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.voucher'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.listing'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.date'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>
          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.changeDefaultImages'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView textId={plan.type === freePlanType ? 'activity.plan.no' : 'activity.plan.yes'} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>

          <div className={classes.viewRowFullWidth}>
            <TextView textId={'activity.plan.price'} variant="body2" color={ColorTitle} />
            <div className={classes.flexGrow} />
            <TextView text={priceText} variant="body2" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
          </div>
          <Space horizontalSpace={1}/>

          {/*{this.oldPlan && !isPlanEnded ?*/}
          {/*  <div className={classes.viewColumnFullWidthNoCenter} style={{opacity: this.oldPlan.planId === plan.id ? 1 : 0}}>*/}
          {/*    <Space horizontalSpace={1.5}/>*/}
          {/*    <Divider style={{width: '100%'}} />*/}
          {/*    <Space horizontalSpace={1.5}/>*/}
          {/*    <div className={classes.viewRowFullWidth}>*/}
          {/*      <TextView textId={'activity.plan.availableViews'} variant="subtitle1" color={ColorTheme} />*/}
          {/*      <div className={classes.flexGrow} />*/}
          {/*      <TextView text={availableViewsText} variant="subtitle1" color={ColorTheme} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
          {/*    </div>*/}
          {/*    <Space horizontalSpace={0.5}/>*/}
          {/*    <div className={classes.viewRowFullWidth}>*/}
          {/*      <TextView text={endAtLabelText} variant="subtitle1" color={ColorTheme} />*/}
          {/*      <div className={classes.flexGrow} />*/}
          {/*      <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
          {/*        <TextView text={endAtText} variant="subtitle1" color={ColorTheme} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <Space horizontalSpace={0.5}/>*/}
          {/*  </div>*/}
          {/*  : null*/}
          {/*}*/}
          {/*{this.oldPlan && isPlanEnded ?*/}
          {/*  <div className={classes.viewColumnFullWidth} style={{opacity: this.oldPlan.planId === plan.id ? 1 : 0}}>*/}
          {/*    <Space horizontalSpace={1.5}/>*/}
          {/*    <Divider style={{width: '100%'}} />*/}
          {/*    <Space horizontalSpace={1.5}/>*/}
          {/*    /!*<div className={classes.viewRowFullWidth} >*!/*/}
          {/*      <TextView textId={'activity.plan.ended'} variant="subtitle1" color={ColorNegative} fontWeight={FONT_WEIGHT_BOLD} textAlign={'center'}/>*/}
          {/*    /!*</div>*!/*/}
          {/*  </div>*/}
          {/*  : null*/}
          {/*}*/}

          <Space horizontalSpace={3}/>
          <Button
            disabled={!buttonEnabled}
            disableElevation
            variant={'contained'}
            color={"primary"}
            onClick={this.onPlanSelected.bind(this, plan)}
            className={classes.buttonCamelCase}>
            {buttonText}
          </Button>
        </div>
        {plan.id === planId ?
          <div style={{position: 'absolute', top: 2, right: 2, backgroundColor: '#eee', borderRadius: 20}}>
            <CheckCircleIcon style={{color: ColorTheme}}/>
          </div>
          : null
        }
      </div>
    );
  }

  onPlanSelected = (item) => {
    this.setState({planId: item.id, planType: item.type, showValidationMsg: false}, () => {
      if (this.props.moveNext) {
        this.props.moveNext();
      }
    });
  }
}

ManageActivityPlan.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  categories: PropTypes.array,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchBusinesses: PropTypes.func,
};

ManageActivityPlan.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {
    defaultMatches: true
  }]
])(ManageActivityPlan)));
